import Vue from 'vue'
import Vuex from 'vuex'

import user from './modules/user'
import error from './modules/error'

Vue.use(Vuex)
const getters = {
  token : state => state.user.token,
  params: state => state.params,
  menu: state => state.currentMenu,
  config: state => state.config
}

export default new Vuex.Store({
  modules: {
    user,
    error
  },
  getters,
  state:{
    params: null,
    currentMenu: null,
    hyperMeeting: null,
    config: null
  },
  mutations: {
    setParams(state, payload) {
      state.params = payload
    },
    setMenu(state, payload) {
      state.currentMenu = payload
    },
    setHyperMeeting(state, payload) {
      state.hyperMeeting = payload
    },
    setConfig(state, payload) {
      state.config = payload
    },
    clearParams(state) {
      state.params = null
    }
  }
})
